import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { ContextConsumer } from "../App";

import { IntlProvider } from "react-intl";

import { CssCounter } from './uikit2';

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Dropdown,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import PATopBar from "./PATopBar";
import { ProductIcon } from '../data/ProductIcon';

export const PASideBar = withRouter( ({ match, location, history } ) => PASideB( { match, location, history } ));

function PASideB( { match, location, history } ) {

  const [state, setState] = useState({
    mishatheme: false,
    menuType: "journeys" //'journeys'
  });
  console.log("path = ", location.pathname);

  const [active, setActive] = useState()

  useEffect(() => {
    // debugger
    match && setActive(match.params['keyId'])
    console.log('active = ', active);
  }, [history])


  // return <PATopBar/>;
  return (
    <CSSsidebar
    className="app-root__sidebar"
    >
      <div style={{
        position: 'fixed',
        width: 220,
        top: 0,
      }}>
      {state.mishatheme && (
        <div

          style={{ width: state.mishatheme ? 460 : 220 }}
        >
          <div
            className="sidebar"
            style={{ width: state.mishatheme ? 460 : 220, zIndex: 0 }}
          >
            <div>
              <div style={{ display: "flex" }}>
                <div
                  className="sidebar-back__arrow"
                  style={{
                    width: 72,
                    // height: 100,
                    display: "flex"
                  }}
                >
                  <i
                    className="xsui-icon xsui-icon-chevron-mini"
                    style={{ fontSize: 36, color: "inherit" }}
                  />
                </div>

                <FormGroup border="lg">
                  <div
                    style={{ flexGrow: 1 }}
                    // className='ui-navigation--bordered'
                  >
                    <div className="sidebar-headshot">ID&nbsp;40702</div>
                    <div className="sidebar-section sidebar-section--bordered">
                      <div className="sidebar-head">
                        <span className="sidebar-head__name">
                          mikastore-25-jan-2019
                        </span>
                      </div>

                      <div
                        className="sidebar-section__items"
                        // style={{ marginLeft: "-4px" }}
                      >
                        <a
                          className="sidebar-section__item"
                          aria-current="false"
                          href="/2340/projects/40702/edit"
                        >
                          {/* <i
                          className="xsui-icon xsui-icon-settings"
                          style={{ fontSize: 24, color: "inherit" }}
                        /> */}
                          Project settings
                        </a>
                      </div>
                    </div>

                    {/* <div className="ui-navigation__section ui-navigation--bordered">
                      <div
                        className="ui-navigation__item"
                        aria-current="true"
                        to="/game_keys"
                      >
                        Products
                      </div>
                      <div
                        className="ui-navigation__item ui-navigation__item--active"
                        aria-current="true"
                        to="/game_keys"
                      >
                        Journeys
                      </div>
                    </div> */}

                    <FormGroup label="Monetize" border />
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      )}

      {!state.mishatheme && (
        <div
          className="app-root__sidebar"
          style={{ width: state.mishatheme ? 560 : 220 }}
        >
          <div
            className="sidebar"
            style={{ width: state.mishatheme ? 560 : 220, zIndex: 0 }}
          >
            <div>
              <div className="sidebar__container sidebar-reverse-animation-enter-done"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingBottom: 0,
              }}
              >
                <FormGroup indentation="xs">
                  <Link to="/dashboard">
                  <div style={{ paddingLeft: 24 }}>
                    <svg
                      width={184}
                      height={72}
                      viewBox="0 0 184 72"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0H72V72H0V0Z"
                        fill="#0073F7"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M46.3912 19.5869L48.5837 17.2216L46.9933 15.5259L44.8165 17.8894L44.8132 17.8833L43.2222 19.5809L43.2256 19.5869L43.2222 19.5905L46.0493 22.6285L43.8759 24.972L45.45 26.6865L49.2222 22.6212L46.3912 19.5869ZM52.2331 44.7151C49.6306 44.7151 47.5083 42.606 47.5083 39.9945C47.5083 37.3818 49.6306 35.2715 52.2331 35.2715C54.8165 35.2715 56.9369 37.3818 56.9369 39.9945C56.9369 42.606 54.8165 44.7151 52.2331 44.7151ZM52.2328 37.8471C51.0362 37.8471 50.0806 38.8235 50.0806 40.0024C50.0806 41.1802 51.0362 42.1396 52.2328 42.1396C53.4095 42.1396 54.3663 41.1802 54.3663 40.0024C54.3663 38.8235 53.4095 37.8471 52.2328 37.8471ZM32.9366 56.7342H35.508V48.1492H32.9366V56.7342ZM38.9373 56.7342H36.3659V48.1492H38.9373V56.7342ZM14.9375 43.8565L20.0889 35.2715L25.2232 43.8565H14.9375ZM20.1059 39.3352L21.5628 41.9576H18.6491L20.1059 39.3352ZM29.4958 16.3845L31.2224 18.1272L28.2418 21.0961L31.2224 24.0847L29.4958 25.8281L26.5072 22.8395L23.5198 25.8281L21.7938 24.0847L24.7837 21.0961L21.7938 18.1272L23.5198 16.3845L26.5072 19.3712L29.4958 16.3845Z"
                        fill="white"
                      />
                      <path
                        d="M88.594 25H91.45L88.202 19.694L91.184 14.962H88.342L86.69 17.748L85.038 14.962H82.224L85.15 19.694L81.888 25H84.842L86.718 21.836L88.594 25ZM95.1534 25.224C97.6734 25.224 98.9054 24.02 98.9054 22.396C98.9054 20.506 97.2254 20.156 95.8254 19.974C94.6214 19.82 93.9354 19.736 93.9354 19.232C93.9354 18.84 94.2154 18.546 94.9994 18.546C95.7694 18.546 96.1894 18.854 96.3014 19.414H98.8074C98.5554 17.79 97.4634 16.698 95.0274 16.698C92.7314 16.698 91.4854 17.804 91.4854 19.386C91.4854 21.318 93.1374 21.626 94.5374 21.808C95.5454 21.934 96.4274 22.004 96.4274 22.564C96.4274 23.012 96.0774 23.278 95.2794 23.278C94.4534 23.278 93.9494 22.97 93.7814 22.284H91.1494C91.4154 24.16 92.7314 25.224 95.1534 25.224ZM103.734 25.21C106.212 25.21 107.836 23.838 107.836 21.136V20.884C107.836 18.168 106.184 16.712 103.748 16.712C101.354 16.712 99.6459 18.126 99.6459 20.884V21.136C99.6459 23.838 101.102 25.21 103.734 25.21ZM103.748 23.012C102.81 23.012 102.18 22.354 102.18 21.108V20.884C102.18 19.526 102.81 18.868 103.762 18.868C104.742 18.868 105.302 19.554 105.302 20.884V21.108C105.302 22.382 104.686 23.012 103.748 23.012ZM111.499 25V14.22H108.923V25H111.499ZM115.491 25V14.22H112.915V25H115.491ZM120.087 23.348C119.471 23.348 119.149 23.11 119.149 22.634C119.149 22.354 119.261 22.158 119.485 21.99C119.737 21.822 120.003 21.752 120.703 21.626C121.193 21.528 121.557 21.43 121.795 21.248V21.738C121.795 22.536 121.109 23.348 120.087 23.348ZM122.187 25H124.287V19.82C124.287 17.944 123.321 16.712 120.633 16.712C118.099 16.712 116.811 17.958 116.685 19.848H119.275C119.303 19.092 119.737 18.672 120.633 18.672C121.501 18.672 121.781 18.994 121.781 19.456C121.781 19.974 121.277 20.114 120.045 20.282C118.729 20.492 118.141 20.604 117.497 21.01C116.839 21.416 116.433 22.046 116.433 23.026C116.433 24.37 117.287 25.21 119.051 25.21C120.563 25.21 121.445 24.552 121.907 23.642L122.187 25ZM86.676 35.118C87.684 35.118 88.23 35.622 88.23 36.476C88.23 37.4 87.642 37.862 86.69 37.862H85.262V35.118H86.676ZM86.76 40.032C89.518 40.046 90.792 38.674 90.792 36.476C90.792 34.348 89.504 32.962 86.718 32.962H82.742V43H85.262V40.032H86.76ZM97.1522 43H99.3082V34.88H96.7182V39.108C96.7182 40.2 96.3822 40.942 95.4862 40.942C94.5762 40.942 94.3522 40.284 94.3522 39.29V34.88H91.8042V40.046C91.8042 42.02 92.6862 43.154 94.4922 43.154C95.7102 43.154 96.5082 42.566 96.9142 41.628L97.1522 43ZM105.55 43.21C107.552 43.21 108.77 41.726 108.77 38.968V38.716C108.77 35.972 107.426 34.726 105.606 34.712C104.472 34.712 103.66 35.258 103.226 36.182V32.22H100.706V43H102.932L103.128 41.642C103.52 42.594 104.318 43.21 105.55 43.21ZM104.724 40.984C103.8 40.984 103.184 40.326 103.184 38.912V38.73C103.184 37.54 103.814 36.826 104.738 36.826C105.62 36.826 106.236 37.47 106.236 38.758V38.954C106.236 40.382 105.662 40.984 104.724 40.984ZM112.429 43V32.22H109.853V43H112.429ZM115.161 34.418C116.197 34.418 116.687 34.082 116.687 33.158C116.687 32.206 116.169 31.884 115.161 31.884C114.139 31.884 113.635 32.206 113.635 33.158C113.635 34.11 114.041 34.418 115.161 34.418ZM113.831 43H116.477V34.922C116.323 35.02 115.595 35.09 115.161 35.09C114.727 35.09 113.971 35.034 113.831 34.936V43ZM121.308 43.224C123.828 43.224 125.06 42.02 125.06 40.396C125.06 38.506 123.38 38.156 121.98 37.974C120.776 37.82 120.09 37.736 120.09 37.232C120.09 36.84 120.37 36.546 121.154 36.546C121.924 36.546 122.344 36.854 122.456 37.414H124.962C124.71 35.79 123.618 34.698 121.182 34.698C118.886 34.698 117.64 35.804 117.64 37.386C117.64 39.318 119.292 39.626 120.692 39.808C121.7 39.934 122.582 40.004 122.582 40.564C122.582 41.012 122.232 41.278 121.434 41.278C120.608 41.278 120.104 40.97 119.936 40.284H117.304C117.57 42.16 118.886 43.224 121.308 43.224ZM128.478 38.758C128.478 37.652 128.856 36.91 129.794 36.91C130.732 36.91 130.998 37.582 130.998 38.562V43H133.56V37.806C133.56 35.846 132.734 34.712 130.9 34.712C129.724 34.712 128.926 35.258 128.478 36.126V32.22H125.944V43H128.478V38.758ZM138.819 36.644C139.771 36.644 140.247 37.176 140.359 38.086H137.153C137.321 37.134 137.867 36.644 138.819 36.644ZM142.823 40.424H140.121C139.925 40.886 139.533 41.194 138.819 41.194C137.839 41.194 137.279 40.662 137.153 39.682H142.879V38.772C142.879 36.574 141.661 34.712 138.791 34.712C136.257 34.712 134.619 36.294 134.619 38.898V39.136C134.619 41.642 135.935 43.21 138.749 43.21C141.115 43.21 142.375 42.132 142.823 40.424ZM146.527 43V39.402C146.527 37.96 146.891 37.442 148.375 37.442H149.327V34.768H148.865C147.409 34.768 146.583 35.286 146.317 36.546L145.967 34.88H143.923V43H146.527ZM87.768 57.164H85.724L86.732 53.902L87.768 57.164ZM89 61H91.576L88.048 50.962H85.444L81.958 61H84.548L85.094 59.236H88.44L89 61ZM95.7632 61.21C98.1292 61.21 99.7532 60.118 99.8512 57.57V57.5H97.2052V57.528C97.1212 58.55 96.6172 59.012 95.7772 59.012C94.8532 59.012 94.2652 58.354 94.2652 57.108V56.884C94.2652 55.526 94.8532 54.868 95.7912 54.868C96.6312 54.868 97.1072 55.302 97.1912 56.296V56.352H99.8372V56.31C99.7392 53.832 98.1292 52.712 95.7772 52.712C93.3972 52.712 91.6752 54.126 91.6752 56.884V57.136C91.6752 59.838 93.1452 61.21 95.7632 61.21ZM104.718 61.21C107.084 61.21 108.708 60.118 108.806 57.57V57.5H106.16V57.528C106.076 58.55 105.572 59.012 104.732 59.012C103.808 59.012 103.22 58.354 103.22 57.108V56.884C103.22 55.526 103.808 54.868 104.746 54.868C105.586 54.868 106.062 55.302 106.146 56.296V56.352H108.792V56.31C108.694 53.832 107.084 52.712 104.732 52.712C102.352 52.712 100.63 54.126 100.63 56.884V57.136C100.63 59.838 102.1 61.21 104.718 61.21ZM113.673 61.21C116.151 61.21 117.775 59.838 117.775 57.136V56.884C117.775 54.168 116.123 52.712 113.687 52.712C111.293 52.712 109.585 54.126 109.585 56.884V57.136C109.585 59.838 111.041 61.21 113.673 61.21ZM113.687 59.012C112.749 59.012 112.119 58.354 112.119 57.108V56.884C112.119 55.526 112.749 54.868 113.701 54.868C114.681 54.868 115.241 55.554 115.241 56.884V57.108C115.241 58.382 114.625 59.012 113.687 59.012ZM124.168 61H126.324V52.88H123.734V57.108C123.734 58.2 123.398 58.942 122.502 58.942C121.592 58.942 121.368 58.284 121.368 57.29V52.88H118.82V58.046C118.82 60.02 119.702 61.154 121.508 61.154C122.726 61.154 123.524 60.566 123.93 59.628L124.168 61ZM130.311 56.758C130.311 55.638 130.675 54.91 131.641 54.91C132.579 54.91 132.831 55.554 132.831 56.562V61H135.407V55.834C135.407 53.874 134.455 52.712 132.649 52.712C131.389 52.712 130.549 53.314 130.129 54.252L129.891 52.88H127.721V61H130.311V56.758ZM141.746 58.634H141.228C140.024 58.634 139.814 58.48 139.814 57.08V55.134H141.746V52.88H139.814V50.85H137.714C137.7 51.186 137.672 51.62 137.63 51.956C137.546 52.642 137.35 52.866 136.832 52.936C136.552 52.992 136.342 53.02 136.034 53.02V55.134H137.406V57.584C137.406 60.118 138.008 61 140.458 61H141.746V58.634Z"
                        fill="#00244D"
                      />
                    </svg>
                  </div>
                  </Link>
                </FormGroup>

                <div className="sidebar-products" style={{flexGrow:1}}>
                  {/* <a
                    className="sidebar-products__item sidebar-products__item--active"
                    href="/store/"
                  > */}

                  {/* <Link
                    className={`sidebar-products__item ${location.pathname.search("/game_keys") > -1 ? ` sidebar-products__item--active` : null}`}
                    to="/microtransactions"
                  >
                    <div className="sidebar-products__icon-wrapper">
                      <div className="sidebar-products__status sidebar-products__status--connected" />
                      <div
                        className="sidebar-products__icon"
                        style={{
                          backgroundImage:
                            'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                        }}
                      />
                    </div>
                    <div className="sidebar-products__label">Store</div>
                  </Link> */}

                  <FormGroup indentation="md">
                    {/* <CssSectionHeader
                      style={{
                        marginRight: 24,
                        marginLeft: 24,
                        marginBottom: 16,
                      }}
                    >Perfomance</CssSectionHeader> */}

                    <Link
                      key="dashboard"
                      className={`sidebar-products__item ${
                        location.pathname.search("dashboard") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/dashboard"
                    >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon name="stats" size={18} />
                        &nbsp;Dashboard
                      </div>
                    </Link>

                    <Link
                      key="Analytics"
                      className={`sidebar-products__item ${
                        location.pathname.search("stats") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/stats"
                    >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon name="analytics" size={18} />
                        &nbsp;Analytics
                      </div>
                    </Link>

                    <Link
                      key="accounting"
                      className={`sidebar-products__item ${
                        location.pathname.search("accounting") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/transactions/registry"
                    >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon name="minimize" size={18} />
                        &nbsp;Accounting
                      </div>
                    </Link>

                    <Link
                      key="subscribers"
                      className={`sidebar-products__item ${
                        location.pathname.search("support/") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/support/subscribers"
                    >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon name="profile" size={18} />
                        &nbsp;Support
                      </div>
                    </Link>

                    <Link
                      key="antifraud"
                      className={`sidebar-products__item ${
                        location.pathname.search("antifraud/") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/antifraud/main"
                    >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon name="lock" size={18} />
                        &nbsp;Antifraud
                      </div>
                    </Link>
                  </FormGroup>





                  <FormGroup indentation="xs">


                    <CssSectionHeader
                      style={{
                        marginRight: 24,
                        marginLeft: 24,
                        marginBottom: 8,
                      }}
                    >
                      <Dropdown
                        // align="left-half-back"
                        autosize={true}
                        separated={false}
                        options={[
                          { label: "Farm Fresh", extra: '12' },
                          {
                            label: (
                              <Button appearance="flatten">
                                <Icon name="add" /> Add new game
                              </Button>
                            )
                          }
                        ]}
                      >
                        <span style={{ display: "flex" }}>
                          <div>
                            <div className="">
                              Farm Fresh
                            </div>
                            {/* <div style={{fontSize: 12,
                              textTransform: 'none',
                              fontWeight: '400'
                              }}>
                              Project id: 2440
                            </div> */}

                            </div> <Icon name="expand" />
                        </span>
                      </Dropdown>
                    </CssSectionHeader>



                    {/* <FormGroup
                      indentation="xs"
                    >
                      <div style={{
                        padding: '8px 24px',
                      }}>

                              <Select
                                name=""
                                options={[
                                  { label: "My project 1", value: "$" },
                                  { label: <Button appearance="flatten"><Icon name="plus"/> Create new project</Button>, value: "rub" },
                                ]}
                                searchable={false}
                                autosize={false}
                                size={"sm"}
                                input={{
                                  value: '$',
                                }}
                              />

                      </div>
                    </FormGroup> */}


                    {/* <CssSectionHeader
                      style={{
                        marginRight: 24,
                        marginLeft: 24,
                        marginBottom: 16,
                      }}
                    >Create</CssSectionHeader> */}




                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("/sb0/bb") > -1
                        ? ` sidebar-products__item--active`
                        : null
                      }`}
                      to="/sb0/bb"
                      >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                        >
                        Game stores <CssCounter>2</CssCounter>
                      </div>
                  </Link> */}





                    {/* <CssSubMenu shown={(
                      location.pathname.search("/sb") > 3
                        )}>
                    <Link
                      style={{width: '100%'}}
                      to="/sb0/sb"
                    >
                      <CssSubLink
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        Landing pages <CssCounter>1</CssCounter>
                      </CssSubLink>
                    </Link>
                    </CssSubMenu> */}




                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("/log") > -1
                        ? ` sidebar-products__item--active`
                          : null
                        }`}
                        to="/sb0/log#login_mail"
                        >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                        >
                        Emails
                      </div>
                    </Link> */}

                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("/ln") > -1
                        ? ` sidebar-products__item--active`
                        : null
                      }`}
                      to="/sb0/ln"
                      >
                      <div
                        className="sidebar-products__label"
                        style={{ display: "flex", alignItems: "center" }}
                        >
                        Launchers <CssCounter>1</CssCounter>
                      </div>
                    </Link> */}






                    {/* <CssSubMenu shown={(
                      location.pathname.search("/site_builder/newsite") > 3
                        )}>
                    <Link
                      style={{width: '100%'}}
                      to="/site_builder/newsite"
                    >
                      <CssSubLink
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Button appearance="flatten"><Icon name='add' size={18} />  Landing page</Button>
                      </CssSubLink>
                    </Link>
                    </CssSubMenu> */}






                  {/* </FormGroup> */}






                  {/* <FormGroup indentation="lg"> */}
                    {/* <CssSectionHeader
                      style={{
                        marginRight: 24,
                        marginLeft: 24,
                        marginBottom: 16,
                      }}
                    >
                      <Dropdown
                        // align="left-half-back"
                        autosize={true}
                        separated={false}
                        options={[
                          { label: "Project 1" },
                          {
                            label: (
                              <Button appearance="flatten">
                                <Icon name="add" /> Create new project
                              </Button>
                            )
                          }
                        ]}
                      >
                        <span style={{ display: "flex" }}>
                          Project 1 <Icon name="expand" />
                        </span>
                      </Dropdown>
                    </CssSectionHeader> */}



                    <Link
                      className={`sidebar-products__item ${
                        (
                        location.pathname.includes("game_store")
                        // || location.pathname.search("buy_button/") > -1
                        // || location.pathname.search("ingame/") > -1
                        )
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/game_store"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Game store
                      </div>
                    </Link>

                    <Link
                      className={`sidebar-products__item ${
                        (
                        location.pathname.includes("microtransactions")
                        // || location.pathname.search("microtransactions/") > -1
                        // || location.pathname.search("ingame/") > -1
                        )
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/microtransactions"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Microtransactions
                      </div>
                    </Link>


                    <Link
                      className={`sidebar-products__item ${
                        (location.pathname.search("subscriptions") > -1)
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/subscriptions"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Subscriptions
                      </div>
                    </Link>






                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("buy_button /") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/game_store/goods"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">Game store</div>
                    </Link> */}

                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("ingame/") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/microtransactions"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        In-game store
                      </div>
                    </Link> */}

                    {/* <Link
                      className={`sidebar-products__item ${
                        location.pathname.search("subscriptions/") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      to="/subscriptions/plans"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/store.34ffc9.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Subscriptions
                      </div>
                    </Link> */}

                    {/* </a> */}

                    <Link
                      to="/login"
                      className={`sidebar-products__item ${
                        location.pathname.includes("login")
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/login.7f900b.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">Login</div>
                    </Link>

                    {/* <Link
                      to="/antifraud/"
                      className="sidebar-products__item"
                      aria-current="false"
                      data-id="open_sb_product_site-builder"
                      exv="[object Object]"
                      href="/2340/projects/40702/site-builder"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/anti-fraud.ac5b8d.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Anti-fraud
                      </div>
                      </Link> */}

                    <Link
                      to="/site_builder"
                      className={`sidebar-products__item ${
                        location.pathname.includes("site_builder")
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                      aria-current="false"
                      data-id="open_sb_product_site-builder"
                      exv="[object Object]"
                      href="/2340/projects/40702/site-builder"
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/site-builder.72ddb3.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">
                        Site Builder
                      </div>
                    </Link>

                    <Link
                      to="/paystation"
                      className={`sidebar-products__item ${
                        location.pathname.search("paystation") > -1
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--connected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/pay-station.bb7931.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">Pay Station</div>
                    </Link>
                  {/* </FormGroup>

                  <FormGroup indentation="lg">
                    <CssSectionHeader style={{
                        marginRight: 24,
                        marginLeft: 24,
                        marginBottom: 16,
                      }}>Connect more</CssSectionHeader> */}

                    <Link
                      to="/partner_network"
                      className={`sidebar-products__item ${
                        location.pathname === "/partner_network"
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--disconnected" />
                        <div
                          // className="sidebar-products__icon"
                        >
                          <ProductIcon
                            name='partner_network'
                            width = {36}
                            height = {36}
                            color = {'#94A7B4'}
                          />
                        </div>
                      </div>
                      <div className="sidebar-products__label">
                        Partner Network
                      </div>
                    </Link>

                    <Link
                      to="/launcher"
                      className={`sidebar-products__item ${
                        location.pathname.includes("launcher")
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--disconnected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/launcher.e1bad3.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">Launcher</div>
                    </Link>


                    <Link
                      to="/"
                      className={`sidebar-products__item ${
                        location.pathname.includes("funding")
                          ? ` sidebar-products__item--active`
                          : null
                      }`}
                    >
                      <div className="sidebar-products__icon-wrapper">
                        <div className="sidebar-products__status sidebar-products__status--disconnected" />
                        <div
                          className="sidebar-products__icon"
                          style={{
                            backgroundImage:
                              'url("//cdn.xsolla.net/publisher-v4/launcher.e1bad3.svg")'
                          }}
                        />
                      </div>
                      <div className="sidebar-products__label">Funding</div>
                    </Link>
                  </FormGroup>
                </div>

                <div className="sidebar-products" style={{flexGrow:0}}>


                   <PAnewUser />

                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </CSSsidebar>
  );
}

PASideBar.propTypes = {};

export default PASideBar;


export const PAnewUser = ({}) => {
  return ( <div
  style={{
    border: '1px solid #ccc',
    borderRadius: 8,
    margin: '0 8px 32px 8px',
  }}
  className="ui-navigation__user">
  <Dropdown
      // align="left-half-back"
      // autosize={true}
      separated={false}
      options={[
        { label: <Link to='/settings/company'>Company settings</Link> },
        { label: <Link to='/settings/api'>API key</Link> },
        { label: <Link to='/settings/users'>Users</Link> },
        { label: <Link to='/settings/contacts'>Contacts</Link> },
        {
          label: (
            <div style={{
              display:'flex',
              alignItems: 'center',
            }}>
              <Icon name="logout" /> Log out
            </div>
          )
        }
      ]}
    >


    <div style={{
      display:'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '8px',
    }}>
      <img src="https://secure.gravatar.com/avatar/104654d561baea867bdf3b65097008d8?s=80&r=g&d=mm" />&nbsp;&nbsp;
      <CssUser style={{
          display: 'flex',
          // color: 'white',
          flexDirection: 'column',
          justifyContent:'flex-start',
          alignItems: 'flex-start',
        }}>
        m.miroshnikov<br/>
        <CssRole>Owner</CssRole>
      </CssUser>
      <Icon name="expand" />
    </div>
  </Dropdown>
  </div>)
}


const CSSsidebar = styled.div`
  @media (max-width: 991px) {

  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (max-width: 479px) {

  }
`;

export const CssSectionHeader = styled.div`
  margin-bottom: 16px;
  padding-bottom: 2px;
  font-size: 12px;
  border-bottom: 1px solid rgba(22, 34, 46, 0.19);
  color: rgba(22, 35, 46, 0.41);
  font-weight: 700;
  text-transform: uppercase;
`;

const CssRole = styled.div`
  background-color: rgb(116, 126, 138);
  color: white;
  font-size: 9px;
  border-radius: 4px;
  padding: 0.0em 0.3em;
  height: 16px;
  /* margin: 0.3em 0em 0px 0px; */
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CssUser = styled.div`
  font-size: 12px;
  color: rgba(22,35,46,0.41);
  font-weight: 700;
  text-transform: uppercase;
`;



const CssSubLink = styled.div`
  /* padding: 16px 24px; */
  padding: 8px 24px;
  width: 100%;
  color: currentColor;
`


const CssSubMenu = styled.div`
  &:hover {
    background-color: rgba(0, 118, 255, .08);
  }
  &:hover a {
    color: #0073f7;
  }
  & a {
    color: currentColor;
  }
  color: #000;
  width: 100%;
  position: relative;
  overflow: hidden;
  transition: all 250ms ease-in-out;
  ${({shown}) => !shown && css`
    /* max-height: 0px; */
    color: #000;
  `};
  ${({shown}) => !!shown && css`
    max-height: 80px;

    &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background-color: #0076ff;
    content: "";

    background-color: rgba(0, 118, 255, .08);
    color: #0076ff;

    /* opacity: 0; */
  }
  `};



`;
